"use client";

import { Skeleton } from "design-system/skeleton";
import dynamic from "next/dynamic";
import { LazyLoadDialog } from "@/components/custom/lazy-load-component";
import type { UseDialogReturn } from "@/lib/hooks/use-dialog";

export function BlockchainAddressesAddFormDialog({ dialogControls }: { dialogControls: UseDialogReturn<void> }) {
  return (
    <LazyLoadDialog dialogControls={dialogControls} title="Add Blockchain Address">
      <BlockchainAddressesAddForm
        dialogControls={dialogControls}
        intendedMutation="adding-new-blockchain-address"
        onSuccess={() => dialogControls?.dismiss()}
        redirectOnSuccess={false}
      />
    </LazyLoadDialog>
  );
}

const BlockchainAddressesAddForm = dynamic(
  () =>
    import("@/subsystems/transfer/accounts/pages/blockchain-addresses-add-form").then(
      (mod) => mod.BlockchainAddressesAddForm,
    ),
  {
    loading: () => (
      <div className="w-full space-y-6">
        {/* Address Nickname Section */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-10 w-full rounded-md" />
          <Skeleton className="h-4 w-80" />
        </div>

        {/* Address Section */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-10 w-full rounded-md" />
          <Skeleton className="h-4 w-48" />
        </div>

        {/* Network Section */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
            <Skeleton className="h-13 rounded-md" />
          </div>
        </div>

        {/* Buttons Section */}
        <div className="flex justify-between">
          <Skeleton className="h-10 w-40 rounded-md" />
          <Skeleton className="h-10 w-40 rounded-md" />
        </div>
      </div>
    ),
    ssr: false,
  },
);
